var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-svg',{staticClass:"close-popup-btn",attrs:{"icon":"ic_close","fill":_vm.color},on:{"click":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }